import { type OrganizationPublicKeyAudience } from "@api/types";

const AUDIENCE_BACKSTAGE: OrganizationPublicKeyAudience = "api-backstage";
const AUDIENCE_INVESTMENTS: OrganizationPublicKeyAudience = "api-investments";

const LABEL_BACKSTAGE = "Back Office API";
const LABEL_INVESTMENTS = "Investor API";

const COLOR_BACKSTAGE = "purple";
const COLOR_INVESTMENTS = "green";

const LABELS: Record<OrganizationPublicKeyAudience, string> = {
  [AUDIENCE_BACKSTAGE]: LABEL_BACKSTAGE,
  [AUDIENCE_INVESTMENTS]: LABEL_INVESTMENTS,
};

const COLORS: Record<OrganizationPublicKeyAudience, string> = {
  [AUDIENCE_BACKSTAGE]: COLOR_BACKSTAGE,
  [AUDIENCE_INVESTMENTS]: COLOR_INVESTMENTS,
};

const getAudienceLabel = (audience: OrganizationPublicKeyAudience): string => {
  const label = LABELS[audience];

  return label;
};

const getAudienceColor = (audience: OrganizationPublicKeyAudience): string => {
  const color = COLORS[audience];

  return color;
};

export {
  LABEL_BACKSTAGE,
  LABEL_INVESTMENTS,
  AUDIENCE_BACKSTAGE,
  getAudienceColor,
  getAudienceLabel,
  AUDIENCE_INVESTMENTS,
};
